import { OrgSettingsSource } from 'src/constants/routes';

import { OrganizationSettingsTab, getOrganizationSettingUrls } from './getOrganizationSettingUrls';

/**
 * Returns the organization settings page that owns a synced setting source.
 */
export const useSyncedOrgSettingUrl = (source: OrgSettingsSource) => {
  switch (source) {
    case OrgSettingsSource.ORG_PRIVACY:
      return getOrganizationSettingUrls({
        tab: OrganizationSettingsTab.PRIVACY,
      });
    case OrgSettingsSource.TEMPLATES:
      return getOrganizationSettingUrls({
        tab: OrganizationSettingsTab.TEMPLATES,
      });
    case OrgSettingsSource.BRANDING_THEME:
      return getOrganizationSettingUrls({
        tab: OrganizationSettingsTab.CANDIDATE_PORTAL_BRANDING_THEMES,
      });
    case OrgSettingsSource.CANDIDATE_PULSE_SURVEY:
      return getOrganizationSettingUrls({
        tab: OrganizationSettingsTab.CANDIDATE_PORTAL_PULSE_SURVEY,
      });
    case OrgSettingsSource.SCHEDULING:
      return getOrganizationSettingUrls({
        tab: OrganizationSettingsTab.SCHEDULE_SETTINGS,
      });
    case OrgSettingsSource.SCHEDULE_LOCATION:
      return getOrganizationSettingUrls({
        tab: OrganizationSettingsTab.SCHEDULE_LOCATION,
      });
    case OrgSettingsSource.DEBRIEF_LOCATION:
      return getOrganizationSettingUrls({
        tab: OrganizationSettingsTab.DEBRIEF_LOCATION,
      });
    case OrgSettingsSource.RESCHEDULING:
      return getOrganizationSettingUrls({
        tab: OrganizationSettingsTab.RESCHEDULING,
      });
    case OrgSettingsSource.INTERVIEW_PLAN_SYNC:
      return getOrganizationSettingUrls({
        tab: OrganizationSettingsTab.INTERVIEW_PLAN_SYNC,
      });
    case OrgSettingsSource.CANDIDATE_AVAILABILITY_REQUEST:
      return getOrganizationSettingUrls({
        tab: OrganizationSettingsTab.CANDIDATE_AVAILABILITY_REQUESTS,
      });
    case OrgSettingsSource.SELF_SCHEDULE_REQUESTS:
      return getOrganizationSettingUrls({
        tab: OrganizationSettingsTab.SELF_SCHEDULE_REQUESTS,
      });
    case OrgSettingsSource.COMMUNICATION:
      return getOrganizationSettingUrls({
        tab: OrganizationSettingsTab.CANDIDATE_COMMUNICATIONS,
      });
    case OrgSettingsSource.DEBRIEF:
      return getOrganizationSettingUrls({
        tab: OrganizationSettingsTab.DEBRIEF_SETTINGS,
      });
    case OrgSettingsSource.INTERNAL_COMMUNICATION:
      return getOrganizationSettingUrls({
        tab: OrganizationSettingsTab.INTERNAL_COMMUNICATIONS,
      });
    case OrgSettingsSource.ORG_SETUP:
      return getOrganizationSettingUrls({
        tab: OrganizationSettingsTab.SETUP,
      });
    default:
      return '';
  }
};
